import Splide from "@splidejs/splide"

const isSplide = document.getElementsByClassName("splide")
if (isSplide.length > 0) {
  window.Splide = Splide
  const carousels = document.querySelectorAll(".splide")

  carousels.forEach((carousel) => {
    let options = {}
    if (carousel.classList.contains("loop")) {
      options = {
        type: "loop",
        perPage: 2.5,
        focus: "center",
        pagination: false,
      }
    }
    const splide = new Splide(carousel, options).mount()
    const filterButtons = carousel.parentNode.parentNode.getElementsByClassName("filterButton")
    const offerFilterButtons = carousel.parentNode.parentNode.getElementsByClassName("offerFilterButtons")
    if (filterButtons) {
      for (const element of filterButtons) {
        element.addEventListener("click", () => {
          splide.refresh()
        })
      }
    }
    if (offerFilterButtons) {
      for (const element of offerFilterButtons) {
        element.addEventListener("click", () => {
          splide.refresh()
        })
      }
    }

    const select = carousel.parentNode.parentNode.querySelector("[id=select]")
    if (select) {
      select.addEventListener("change", () => {
        splide.go(0)
        splide.refresh()
      })
    }
  })
}
